/**
 * Filters Service - Filtros de pesquisa, período e área
 */
import ClassificationService from './classification'

function normalizeArea(area) {
  return String(area || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

const FiltersService = {
  calcularPeriodoDatas(type, offset = 0) {
    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)
    let startDate, endDate

    switch (type) {
      case 'today':
        startDate = new Date(hoje)
        endDate = new Date(hoje)
        endDate.setHours(23, 59, 59, 999)
        break
      case 'week': {
        const diaSemana = hoje.getDay()
        startDate = new Date(hoje)
        startDate.setDate(hoje.getDate() - diaSemana + offset * 7)
        endDate = new Date(startDate)
        endDate.setDate(startDate.getDate() + 6)
        endDate.setHours(23, 59, 59, 999)
        break
      }
      case 'month':
        startDate = new Date(hoje.getFullYear(), hoje.getMonth() + offset, 1)
        endDate = new Date(hoje.getFullYear(), hoje.getMonth() + offset + 1, 0)
        endDate.setHours(23, 59, 59, 999)
        break
      default:
        return { startDate: null, endDate: null }
    }
    return { startDate, endDate }
  },

  filtrarPorPeriodo(prazos, period) {
    const { startDate, endDate } = this.calcularPeriodoDatas(period)
    if (!startDate || !endDate) return prazos
    return prazos.filter((p) => {
      const dataPrazo = p.data || p.dataVencimento
      if (!dataPrazo) return true
      const d = new Date(dataPrazo)
      return d >= startDate && d <= endDate
    })
  },

  filtrarPorData(prazos, date) {
    if (!date) return prazos
    return prazos.filter((p) => {
      const dataPrazo = p.data || p.dataVencimento
      if (!dataPrazo) return false
      const prazoDate = new Date(dataPrazo)
      if (Number.isNaN(prazoDate.getTime())) return false
      const ano = prazoDate.getFullYear()
      const mes = String(prazoDate.getMonth() + 1).padStart(2, '0')
      const dia = String(prazoDate.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}` === date
    })
  },

  filtrarPorArea(prazos, area) {
    if (!area || area === 'all' || area === '') return prazos

    const normalizedArea = normalizeArea(area)

    return prazos.filter((p) => {
      const prazoArea = ClassificationService.resolveArea(p)
      return normalizeArea(prazoArea) === normalizedArea
    })
  },

  filtrarPorResponsavel(prazos, responsavel) {
    if (!responsavel || responsavel === 'all' || responsavel === '') return prazos

    const normalizedResponsavel = normalizeArea(responsavel)

    return prazos.filter((p) => normalizeArea(p.responsavel) === normalizedResponsavel)
  },

  filtrarPorPesquisa(prazos, term) {
    if (!term) return prazos
    const t = term.toLowerCase()
    return prazos.filter(
      (p) =>
        (p.numeroProcesso || '').toLowerCase().includes(t) ||
        (p.descricao || '').toLowerCase().includes(t) ||
        (p.responsavel || '').toLowerCase().includes(t) ||
        (p.titulo || '').toLowerCase().includes(t)
    )
  },

  aplicarTodosFiltros(prazos, { area, period, search, date, responsavel }) {
    let result = this.filtrarPorPesquisa(prazos, search)
    result = this.filtrarPorPeriodo(result, period)
    result = this.filtrarPorData(result, date)
    result = this.filtrarPorArea(result, area)
    result = this.filtrarPorResponsavel(result, responsavel)
    return result
  },
}

export default FiltersService
